import React, { useState, useEffect} from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from 'react-router-dom';
import { endpoints } from "../../services/apiurl";
import { InfinitySpin } from "react-loader-spinner";
import { Button, Grid,FormControl } from "@mui/material";
import Card from "@mui/material/Card";

import EditIcon from "@mui/icons-material/Edit";

import "react-confirm-alert/src/react-confirm-alert.css";
import PageTitle from "../UI/PageTitle";
import Input from "../UI/Input/Input";
const PaidReservationList = () => {

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [DataisLoaded, setDataisLoaded] = useState(false);
  const [show_app, setShowApp] = useState("");
  const [show_web, setShowWeb] = useState("");
  const [order_by_name, setOrderBy] = useState("");

  useEffect(() => {
    fetchData(1, perPage);
  }, [perPage]);

  useEffect(() => {
    // handleSearch(1, perPage);
  }, [perPage]);

  //console.log(localStorage.getItem("user"));
  let a = localStorage.getItem("user");
  let b = JSON.parse(a);
  

  let rest_id = b.restro_id;

  const fetchData = async (page, per_page) => {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;

    await axios
      .post(endpoints.getRestaurents, {
        page,
        per_page,
        user_id,
        restro_id,
      })
      .then(
        (response) => {
          //console.log(response.data.data);
          //console.log(response.data.total);

          setIsLoaded(true);
          setItems(response.data.data);
          setTotalRows(response.data.total);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

 

  const columns = [
        {
          name: "NAME",
          selector: (row) => row.name,
        },
    
        {
          name: "STATUS",
          selector: (row) => (row.status == 1 ? "Active" : "Inactive"),
        },
    
        {
          name: "ACTION",
          cell: (row) => (
            <div>
              {" "}
              <Link to={`/dashboard/editpaidreservation/${row.id}`}>
                {" "}
                <EditIcon />{" "}
              </Link>
        
    
           
            </div>
          ),
          selector: (row) => row.id,
        
        },
      ];

  const handleSearch = async (
    page,
    per_page,
    show_web,
    show_app,
    order_by_name,
    searchQuery = ""
  ) => {
    try {
      const response = await axios.post(endpoints.rest_filter, {
        page,
        per_page,
        searchQuery,
        show_web,
        show_app,
        order_by_name,
      });
      setIsLoaded(true);
      setItems(response.data.data);
      setTotalRows(response.data.total);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
      //console.error("Error filtering restaurants:", error);
    }
  };

  const handleInputChange = async (e) => {
    const inputValue = e.target.value;
    setSearchQuery(inputValue);

    if (rest_id === 0) {
      if (inputValue.trim() !== "") {
        await handleSearch(1, 10, show_web, show_app, order_by_name, inputValue);
      } else {
        await handleSearch(1, 10, show_web, show_app, order_by_name, "");
      }
    } else {
      fetchData(1, 10);
    }
  };


  const handlePageChange = (page) => {
    if (rest_id === 0) {
      handleSearch(page, 10, show_web, show_app, order_by_name, searchQuery);
    } else {
      fetchData(page, 10);
    }
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    if (rest_id === 0) {
      handleSearch(
        page,
        newPerPage,
        show_web,
        show_app,
        order_by_name,
        searchQuery
      );
    } else {
      fetchData(page, newPerPage);
    }
  };

  const handleResetFilters = async () => {
    // Reset all filter states
    setShowApp("");
    setShowWeb("");
    setOrderBy("");
    setSearchQuery("");

    await handleSearch(1, 10, "", "", "", "");
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <div>

<div className="spinner">
            <InfinitySpin
              visible={true}
              width="200"
              color="#fbaa1a"
              ariaLabel="infinity-spin-loading"
            />
            
          </div>
    </div>;
  } else {
    return (
      <div className="App">
        {rest_id === 0 ? (
          <PageTitle
          
           title="Paid Reservation List"
           
          
          />
        ) : (
          ""
        )}

        <Card className="mt-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            highlightOnHover
            subHeader
            subHeaderComponent={
              rest_id === 0 && (
              <Grid
                container
                spacing={2}
                justifyContent="left"
                alignItems="center"
                style={{ padding: "10px" }}
              >
              
                <Grid item xs={12} md={3} textAlign="center">
                  <FormControl fullWidth style={{ marginTop: "-26px" }}>
                    <Input
                      type="text"
                      value={searchQuery}
                      onChange={handleInputChange}
                      place="Search restaurant"
                      className="form-control"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={2} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleResetFilters}
                  >
                    Reset Filter
                  </Button>
                </Grid>
             
              </Grid>
              )
            }
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
};

export default PaidReservationList;
